import { put, all, race, take } from 'redux-saga/effects';

export function* waitFor(action, successAction, failedAction) {
  action = typeof action === 'function' ? action() : action;

  const { result } = yield all({
    action: yield put(action),
    result: yield race({
      success: take(successAction),
      failure: take(failedAction)
    })
  });

  if (result.failure) {
    console.error(result.failure); // need proper logging
    return;
    // throw new Error(result.failure.payload);
  }

  return result.success.payload;
}
